import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

export { default as Slider } from 'react-slick';
